import Button from '@rio-cloud/rio-uikit/Button';
import { useIntl } from 'react-intl';

import { downloadOrderImportTemplate } from '../service/orderImportTemplate.ts';

type CsvImportDialogFooterProps = {
    isCreatingOrders: boolean;
    isSubmitDisabled: boolean;
    onCancel: () => void;
    onSubmit: () => void;
};

export const CsvImportDialogFooter = ({
    isCreatingOrders,
    isSubmitDisabled,
    onCancel,
    onSubmit,
}: CsvImportDialogFooterProps) => {
    const intl = useIntl();

    return (
        <div className='display-flex align-items-center justify-content-between width-100pct'>
            <div className='display-flex align-items-center flex-wrap text-muted'>
                <span className='margin-right-5'>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.template-examples',
                    })}
                    {':'}
                </span>
                <Button
                    bsStyle={Button.PRIMARY}
                    variant={Button.VARIANT_LINK_INLINE}
                    autoTrackingKey='ordercom.orders.csv-import.template.bulk'
                    onClick={() => downloadOrderImportTemplate('bulk', intl.locale)}
                >
                    Bulk XLSX
                </Button>
                <span className='margin-right-5'>{','}</span>

                <Button
                    bsStyle={Button.PRIMARY}
                    variant={Button.VARIANT_LINK_INLINE}
                    autoTrackingKey='ordercom.orders.csv-import.template.cargo'
                    onClick={() => downloadOrderImportTemplate('cargo', intl.locale)}
                >
                    Cargo XLSX
                </Button>
            </div>
            <div className='display-flex align-items-center gap-10'>
                <div className='text-muted'>
                    {isCreatingOrders &&
                        intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.create-progress',
                        })}
                </div>
                <div className='btn-toolbar'>
                    <Button
                        bsStyle={Button.DEFAULT}
                        autoTrackingKey='intl-msg:ordercom-cloud-frontend.orders.csv-import.cancel'
                        onClick={onCancel}
                    >
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.cancel',
                        })}
                    </Button>
                    <Button
                        bsStyle={Button.PRIMARY}
                        data-testid='csv-import-submit'
                        disabled={isSubmitDisabled}
                        autoTrackingKey='intl-msg:ordercom-cloud-frontend.orders.csv-import.submit'
                        onClick={onSubmit}
                    >
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.orders.csv-import.submit',
                        })}
                    </Button>
                </div>
            </div>
        </div>
    );
};
